export default "__VITE_ASSET__DSGfDDoR__"